import * as yup from 'yup'

import { ImageSchema } from './ImageSchema'

const NameTranslationObject = yup.object().shape({
  languageCode: yup.string(),
  value: yup.string().required('knowledgeBase.errors.name.required')
})

const ImagePathSchema = yup.string().nullable()

const CreateGroupSchema = yup.object().shape({
  name: yup.string().required('knowledgeBase.errors.name.required'),
  nameTranslations: yup.array().of(NameTranslationObject),
  image: yup.lazy((value) => {
    if (value == null || typeof value === 'string') {
      return ImagePathSchema
    }
    return ImageSchema
  }),
  labelIds: yup.array().of(yup.number()),
})

const EditGroupSchema = CreateGroupSchema

export {
  CreateGroupSchema,
  EditGroupSchema
}
